import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=fc192a36&scoped=true"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"
import style0 from "./Release.vue?vue&type=style&index=0&id=fc192a36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc192a36",
  null
  
)

export default component.exports